import { createSlice } from '@reduxjs/toolkit'
import {
  FetchPackingAllocationsDispatchById,
  fetchDropdownByColumnPackingAllocations,
  UpdateStatusInPackingAllocations,
  exportUsersCSV,
  updateStatusInUpdatefetchPackingAllocations,
  PackingAllocationsDispatch,
} from './thunk'

interface PackingAllocationsDispatchState {
  packing_allocations_dispatch_list: any[]
  rowCount: number
  loading: boolean
  error: string | null
  selectedOrganisation: any
  orgDropDown: any[]
  industryTypeDropDown: any[]
  orgCityDropDown: any[]
  orgStateDropDown: any[]
  pincodeDropDown: any[]
  dynamicDropdowns: Record<string, any[]>
  exportCSVLoading: boolean
  exportCSVError: string | null
  userFormDropDowns: {
    userTypes: any[]
    organizations: any[]
    departments: any[]
    teams: any[]
    states: any[]
  }
}

const initialState: PackingAllocationsDispatchState = {
  packing_allocations_dispatch_list: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedOrganisation: null,
  orgDropDown: [],
  industryTypeDropDown: [],
  orgCityDropDown: [],
  orgStateDropDown: [],
  pincodeDropDown: [],
  dynamicDropdowns: {},
  exportCSVLoading: false,
  exportCSVError: null,
  userFormDropDowns: {
    userTypes: [],
    organizations: [],
    departments: [],
    teams: [],
    states: []
  }
}

const PackingAllocationsDispatchSlice = createSlice({
  name: 'packingAllocationsDispatch',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      // Fetch packing allocations dispatch list
      .addCase(PackingAllocationsDispatch.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(PackingAllocationsDispatch.fulfilled, (state, action) => {
        state.loading = false
        state.packing_allocations_dispatch_list = Array.isArray(action.payload.data)
          ? action.payload.data
          : []
        state.rowCount = typeof action.payload.rowCount === 'number'
          ? action.payload.rowCount
          : 0
      })
      .addCase(PackingAllocationsDispatch.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Failed to fetch packing allocations dispatch list'
      })

      // Fetch by ID
      .addCase(FetchPackingAllocationsDispatchById.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(FetchPackingAllocationsDispatchById.fulfilled, (state, action) => {
        state.loading = false
        state.selectedOrganisation = action.payload
      })
      .addCase(FetchPackingAllocationsDispatchById.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })

      // Update Status
      .addCase(UpdateStatusInPackingAllocations.fulfilled, (state: any, action: any) => {
        if (!action.payload?.id) return
        state.packing_allocations_dispatch_list = state.packing_allocations_dispatch_list.map((org: any) =>
          org.id === action.payload.id ? action.payload : org
        )
      })
      .addCase(UpdateStatusInPackingAllocations.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Failed to update status'
      })

      // Update status from update fetch
      .addCase(updateStatusInUpdatefetchPackingAllocations.fulfilled, (state: any, action: any) => {
        if (!action.payload?.id) return
        state.packing_allocations_dispatch_list = state.packing_allocations_dispatch_list.map((org: any) =>
          org.id === action.payload.id ? action.payload : org
        )
      })
      .addCase(updateStatusInUpdatefetchPackingAllocations.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Failed to update status from fetch'
      })

      // Export CSV
      .addCase(exportUsersCSV.pending, state => {
        state.exportCSVLoading = true
        state.exportCSVError = null
      })
      .addCase(exportUsersCSV.fulfilled, state => {
        state.exportCSVLoading = false
        state.exportCSVError = null
      })
      .addCase(exportUsersCSV.rejected, (state, action) => {
        state.exportCSVLoading = false
        state.exportCSVError = typeof action.payload === 'string'
          ? action.payload
          : action.error.message || 'Failed to export CSV'
      })

      // Single handler for fetchDropdownByColumnPackingAllocations
      .addCase(fetchDropdownByColumnPackingAllocations.fulfilled, (state: any, action: any) => {
        const columnId = action.meta?.arg

        if (columnId) {
          const key = `${columnId}DropDown`
          state.dynamicDropdowns = {
            ...state.dynamicDropdowns,
            [key]: action.payload
          }
        } else {
          state.userFormDropDowns = action.payload
        }
      })
  }
})

export default PackingAllocationsDispatchSlice.reducer
